export interface ClientBuildInfo {
  version?: string
  buildId?: string
}

type NextDataLike = {
  buildId?: unknown
}

function normalize(value: unknown, maxLength = 120): string | undefined {
  if (typeof value !== 'string') {
    return undefined
  }

  const trimmed = value.trim().slice(0, maxLength)
  return trimmed.length > 0 ? trimmed : undefined
}

function readNextBuildId(): string | undefined {
  if (typeof window === 'undefined') {
    return undefined
  }

  const maybeNextData = (window as Window & { __NEXT_DATA__?: NextDataLike }).__NEXT_DATA__
  return normalize(maybeNextData?.buildId)
}

export function getClientBuildInfo(): ClientBuildInfo {
  const buildId = normalize(process.env.NEXT_PUBLIC_APP_BUILD_ID) ?? readNextBuildId()
  const version = normalize(process.env.NEXT_PUBLIC_APP_VERSION) ?? buildId

  return {
    version,
    buildId,
  }
}
